// copied from calling-widget-ui/userSettings/constants/UserSettingsKeys
export const DEFAULT_DUE_DATE_PRESET_KEY = 'Tasks:Defaults:DueDatePreset';
export const DEFAULT_DUE_TIME_KEY = 'Tasks:Defaults:DueTime';
export const DEFAULT_REMINDER_PRESET_KEY = 'Tasks:Defaults:ReminderPreset';
export const USER_SETTINGS_KEYS = [DEFAULT_DUE_DATE_PRESET_KEY, DEFAULT_DUE_TIME_KEY, DEFAULT_REMINDER_PRESET_KEY];